import { Dimmer, Loader } from "semantic-ui-react";

import React from "react";

interface SimpleLoaderProps {
    message?: string;
}
const SimpleLoader: React.FC<SimpleLoaderProps> = (props: SimpleLoaderProps) => {
    const { message } = props;
    return (
        <Dimmer active inverted page inline="centered">
            <Loader inline content={message} size="big" />
        </Dimmer>
    );
};

export default SimpleLoader;
